<app-modal>
    <ng-container title>
        {{ 'FEATURES.AGREEMENTS.ADD_TO_CALENDAR' | translate }}
    </ng-container>
    <ng-container body>
        <table class="calendar-table">
            <thead>
                <tr>
                    <th>{{ 'FEATURES.AGREEMENTS.CALENDAR_DATE_COLUMN' | translate }}</th>
                    <th>Google</th>
                    <th>Outlook</th>
                    <th>ICS</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let date of dates; let i = index" [ngClass]="{ past: isDateInPast(date) }">
                    <td>{{ date | date: 'yyyy-MM-dd' }}</td>
                    <td>
                        <a
                            [href]="getGoogleCalendarUrl(date)"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="cal-link"
                            >Google</a
                        >
                    </td>
                    <td>
                        <a
                            [href]="getOutlookCalendarUrl(date)"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="cal-link"
                            >Outlook</a
                        >
                    </td>
                    <td>
                        <button type="button" class="cal-link" (click)="downloadSingleEvent(date, i)">ICS</button>
                    </td>
                </tr>
            </tbody>
        </table>
    </ng-container>
    <ng-container footer>
        <button type="button" class="secondary" (click)="downloadAllCalendar()">
            <span class="material-symbols-rounded" aria-hidden="true">calendar_add_on</span>
            {{ 'FEATURES.AGREEMENTS.CALENDAR_DOWNLOAD_ALL' | translate }}
        </button>
        <button type="button" class="primary" (click)="close()">
            {{ 'BUTTONS.CLOSE' | translate }}
        </button>
    </ng-container>
</app-modal>
